<template>
    <div class="commit-component">
        <span class="commit-component-icon"></span>
        <span class="commit-component-number">{{commitNumber}}</span>
    </div>
</template>

<style lang="less">
    @import '../assets/less/components/commit.less';
</style>

<script>
import {limitMaxNum} from '@/utils/matchFilter';

export default {
    props: {
        commitnumber: {
            'type': Number,
            'default': 0
        }
    },
    computed: {
        commitNumber: {
            get() {
                return limitMaxNum(this.commitnumber);
            }
        }
    }
};
</script>